import { UserRoleValue } from 'generated/graphql';

export default (roles: UserRoleValue[] | undefined): string =>
  roles && roles[0] ? roles[0].toLowerCase() : 'read-only';
